export default __webpack_public_path__ + "static/media/eye-closed.b641a182.svg";